import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/platform/')({
  component: () => <Navigate to="/platform/account" />,
})
